// element/index.js
import {
  Button,
  Select,
  Switch,
  MessageBox,
  Message,
  DatePicker,
  TimePicker,
  Input,
  Form,
  FormItem,
  Container,
  Aside,
  Header,
  Main,
  Menu,
  MenuItem,
  MenuItemGroup,
  Submenu,
  Scrollbar,
  Breadcrumb,
  BreadcrumbItem,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Tabs,
  TabPane,
  Tooltip,
  Row,
  Col,
  Option,
  Table,
  TableColumn,
  Card,
  Pagination,
  Dialog,
  Avatar,
  Checkbox,
  CheckboxGroup,
  Radio,
  RadioGroup,
  Upload,
  Cascader,
  Loading
} from 'element-ui'
const element = {
  install: function (Vue) {
    Vue.use(Button);
    Vue.use(Switch);
    Vue.use(Select);
    Vue.use(DatePicker);
    Vue.use(TimePicker);
    Vue.use(Input);
    Vue.use(Form);
    Vue.use(FormItem);
    Vue.use(Container);
    Vue.use(Aside);
    Vue.use(Header);
    Vue.use(Main);
    Vue.use(Menu);
    Vue.use(MenuItem);
    Vue.use(MenuItemGroup);
    Vue.use(Submenu);
    Vue.use(Scrollbar);
    Vue.use(Breadcrumb);
    Vue.use(BreadcrumbItem);
    Vue.use(Dropdown);
    Vue.use(DropdownItem);
    Vue.use(DropdownMenu);
    Vue.use(Tabs);
    Vue.use(TabPane);
    Vue.use(Tooltip);
    Vue.use(Row);
    Vue.use(Col);
    Vue.use(Option);
    Vue.use(Table);
    Vue.use(TableColumn);
    Vue.use(Card);
    Vue.use(Pagination);
    Vue.use(Dialog);
    Vue.use(Avatar);
    Vue.use(Checkbox);
    Vue.use(CheckboxGroup);
    Vue.use(Radio);
    Vue.use(RadioGroup);
    Vue.use(Upload);
    Vue.use(Cascader);
    Vue.use(Loading);
    Vue.prototype.$msgbox = MessageBox;
    Vue.prototype.$alert = MessageBox.alert;
    Vue.prototype.$confirm = MessageBox.confirm;
    Vue.prototype.$message = Message
  }
};
export default element



// WEBPACK FOOTER //
// ./src/element/index.js